import { atom } from 'recoil';
export const manageClassesState = atom({
    key: 'manageClasses',
    default: {
        classes: { data: [], count: 0, page: 0, pageCount: 0, total: 0 },
        isTableLoading: false,
        isLoading: false,
        reloadClasses: false,
        classGrade: null,
        assignedTeacher: null,
        grades: [],
        filters: { input: '', selectedGradeId: null },
        dataNotFound: false,
        teachers: [],
        isAddClassModalVisible: false
    }
});
